var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1864_801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1864_801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 22.0001C11.2496 22.0001 10.0788 21.7626 8.98711 21.2876C7.89544 20.8126 6.94544 20.1709 6.13711 19.3626C5.32878 18.5543 4.68711 17.6043 4.21211 16.5126C3.73711 15.4209 3.49961 14.2501 3.49961 13.0001C3.49961 11.7501 3.73711 10.5793 4.21211 9.4876C4.68711 8.39593 5.32878 7.44593 6.13711 6.6376C6.94544 5.82926 7.89544 5.1876 8.98711 4.7126C10.0788 4.2376 11.2496 4.0001 12.4996 4.0001C13.7496 4.0001 14.9204 4.2376 16.0121 4.7126C17.1038 5.1876 18.0538 5.82926 18.8621 6.6376C19.6704 7.44593 20.3121 8.39593 20.7871 9.4876C21.2621 10.5793 21.4996 11.7501 21.4996 13.0001C21.4996 14.2501 21.2621 15.4209 20.7871 16.5126C20.3121 17.6043 19.6704 18.5543 18.8621 19.3626C18.0538 20.1709 17.1038 20.8126 16.0121 21.2876C14.9204 21.7626 13.7496 22.0001 12.4996 22.0001ZM15.2996 17.2001L16.6996 15.8001L13.4996 12.6001V8.0001H11.4996V13.4001L15.2996 17.2001ZM6.09961 2.3501L7.49961 3.7501L3.24961 8.0001L1.84961 6.6001L6.09961 2.3501ZM18.8996 2.3501L23.1496 6.6001L21.7496 8.0001L17.4996 3.7501L18.8996 2.3501ZM12.4996 20.0001C14.4496 20.0001 16.1038 19.3209 17.4621 17.9626C18.8204 16.6043 19.4996 14.9501 19.4996 13.0001C19.4996 11.0501 18.8204 9.39593 17.4621 8.0376C16.1038 6.67926 14.4496 6.0001 12.4996 6.0001C10.5496 6.0001 8.89544 6.67926 7.53711 8.0376C6.17878 9.39593 5.49961 11.0501 5.49961 13.0001C5.49961 14.9501 6.17878 16.6043 7.53711 17.9626C8.89544 19.3209 10.5496 20.0001 12.4996 20.0001Z",
    fill: "#3E4143"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.76437ce863191c0731267e1f471291df.svg";
export { ForwardRef as ReactComponent };